import { render, staticRenderFns } from "./ProductDesc.vue?vue&type=template&id=48a452aa&scoped=true"
import script from "./ProductDesc.vue?vue&type=script&lang=js"
export * from "./ProductDesc.vue?vue&type=script&lang=js"
import style0 from "./ProductDesc.vue?vue&type=style&index=0&id=48a452aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a452aa",
  null
  
)

export default component.exports